'use strict';

$(document).ready(() => {
  if (null !== document.querySelector('[data-event-symfony-form]')) {
    const SymfonyForm = require('./form');
    SymfonyForm.bindEventListeners();
  }
});
